<template>
  <div class="mr-header-box">
    <div class="v-header">
      <img src="../images/top_left.png" style="height:35px;margin-left:20px;"/>
    </div>
    <img src="../images/title.png" style="width:480px;"/>
    <div style="display:flex;">
      <div class="v-card-weather">
        <div class="vc-list">
          <span class="img"><img v-if="screenData.image" :src="imgObj[screenData.image]" alt=""></span>
          <div>
            <p class="label">{{screenData.city}} {{ screenData.area }}</p>
            <p class="value">{{screenData.temprature}} {{screenData.tianqi}}</p>
          </div>
        </div>
        <div class="vc-list">
          <p class="label">空气质量</p>
          <p class="tag">{{screenData.air}}</p>
        </div>
        <div class="vc-list">
          <p class="label">风力</p>
          <p>{{screenData.wind}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MrHeaderBox",
  components: {},
  computed: {
    ...mapState(["projectCurrentRowData"])
  },
  mounted() {
    this.projectData=this.projectCurrentRowData || {};
    this.initData();
  },
  data() {
    return {
      projectData: {},
      screenData: {},
      imgObj: {
        qing: require("@/assets/images/weather/qing.png"),
        dalei: require("@/assets/images/weather/dalei.png"),
        dawu: require("@/assets/images/weather/dawu.png"),
        duoyun: require("@/assets/images/weather/duoyun.png"),
        bingbao: require("@/assets/images/weather/bingbao.png"),
        shachen: require("@/assets/images/weather/shachen.png"),
        xue: require("@/assets/images/weather/xue.png"),
        yin: require("@/assets/images/weather/yin.png"),
        yu: require("@/assets/images/weather/yu.png"),
        feng: require("@/assets/images/weather/feng.png"),
      }
    }
  },
  methods: {
    initData() {
      this.request.screenWeather({ project: this.projectData.projectCode }).then(res => {
        if (res.code == 0) {
          this.screenData = Object.assign({}, res.data);
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.v-header {
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  > span {
    ::v-deep .v-title-bg {
      font-family: Do Hyeon;
      font-size: 28px;
      background: linear-gradient(
        180deg,
        #ffffff 0%,
        rgba(232, 249, 255, 0.84) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      position: relative;
    }
  }
  > .vh-list {
    margin: 0 0 0 28px;

    ::v-deep .el-select {
      .el-input input {
        background-color: transparent;
        border: none;
        color: #FFFFFF;
        font-size: 18px;
      }
      .el-input__suffix {
        right: 15%;
      }
    }
  }

  > .vh-searchInput {
    transition: all 0.2s linear;
    background-color: transparent;
    .vh-searchInput-icon {
      cursor: pointer;
    }

    ::v-deep .el-input__inner {
      padding: 0;
      min-width: 24px;
      height: 24px;
      opacity: 1;
      box-sizing: border-box;
      border: 1px solid rgba(242, 243, 245, 0.15);
      background-color: transparent;
      border-radius: 50%;
      color: #fff;
    }

    ::v-deep .el-input__prefix {
      left: 0;
      line-height: 24px;
    }

    &.searchInput--large ::v-deep .el-input__inner {
      padding-left: 24px;
      border-radius: 4px;
    }
  }
}  
.mr-header-box {
  height: 64px;
  background-image: url('../images/title_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.v-card-weather {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 321.33px;
  padding-right: 12px;
  box-sizing: border-box;
  .vc-list {
    flex: 1;
    position: relative;
    .img {
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      left: -24px;
      top: 0;
      bottom: 0;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      text-align: center;
      line-height: 24px;
      color: #FFFFFF;
    }
    p.label {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 12px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.6);
    }
    p.value {
      font-family: "microsoft yahei ui","microsoft yahei";
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0em;
      color: #FFFFFF;
      &.tag {
        color: rgba(106, 255, 213, 0.9412);
      }
    }
  }
}
</style>